import { render, staticRenderFns } from "./pageForm.vue?vue&type=template&id=5b3d3573&scoped=true&"
import script from "./pageForm.vue?vue&type=script&lang=babel&"
export * from "./pageForm.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3d3573",
  null
  
)

export default component.exports